import { StyleSheet, View } from 'react-native'
import Toast from 'react-native-toast-message'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { globalStyles } from '../../../static/styles/global'
import SignatureFormView from '../SignatureFormView'
const KsinformationOnline = ({ navigation, route }) => {
    const {
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,

    } = route.params

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postKSonline, } = useFormsStore()


    const handlesubmit = async (signatureDataURL: any) => {

        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey: intializeStore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            allowanceRate: values?.AllowanceRate,
            Total: values?.Total ? values?.Total : null,
            additionalAmount: values?.additional ? values?.additional : null,
            withholdingExempt: values?.exempt,
            sign: signatureDataURL
        }
        const response: any = await postKSonline(data)
        if (response?.success === true) {

            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }


    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'Kansas Withholding'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('KsinformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />
        </>
    )
}

export default KsinformationOnline

const styles = StyleSheet.create({})